module.exports = __webpack_public_path__ + "media/components/resources/grid/img/gradient-star-ac236c448ff35c7ab3ae59b6f5b1c846.svg";